import Modal from './Box';

$(document.documentElement).on('click', 'a[target="lightbox"]', function(event) {
	event.preventDefault();
	let href = $(this).attr('href');
	if (href) {
		let html = '<div class="lightbox-iframe-wrapper"><iframe class="lightbox-iframe" src="' + href + '?lightbox=1"></iframe></div>';
		let modalElement = new Modal({
			autoOpen: true,
			content: html,
			className: 'zoom'
		});
	}
});

$(document.documentElement).on('click', 'a[target="inline-lightbox"]', function(event) {

	event.preventDefault();
	let html = '<div class="lightbox-html-wrapper"><div class="lightbox-html">' + $($(this).attr('href')).html() + '</div></div></div>';
	let size = $(this).data('lightbox-size');
	let modalElement = new Modal({
		autoOpen: true,
		content: html,
		className: 'zoom' + (size === 'large' ? ' zoom--large' : '')
	});

	setTimeout(() => {
		let wrapper = document.querySelector('.lightbox-html-wrapper');
		wrapper.style.height = '';

		let inner = document.querySelector('.scotch-open .lightbox-html__inner');
		if (inner) {
			let maxHeight = window.innerHeight / 100 * 80;
			let height = inner.getBoundingClientRect().height;
			if (height) {
				wrapper.style.height = Math.min(height, maxHeight) + 'px';
			}
		}
	}, 750);
});

if(window.location.hash) {
	let hash = window.location.hash.substring(1);
	let modalAnchor = $("a[href~='#" + hash + "']")
	if(modalAnchor.length) {
		modalAnchor.click();
	}
}
